import { DivIcon } from 'leaflet';
import { stressClassFor } from './formatters';
import { makeStressBarsHtml } from './flightHeuristics';

export const makeRunSplitDivIcon = (km: number, hrLevel: number): DivIcon => {
  const klass = stressClassFor(hrLevel);
  const barsHtml = hrLevel > 0 ? makeStressBarsHtml(hrLevel) : '';
  const html = `<div class="run-split-badge ${klass}"><span class="run-split-km">${km}k</span>${barsHtml}</div>`;
  return new DivIcon({
    html,
    className: 'flight-movement-divicon',
    iconSize: [1, 1],
    iconAnchor: [12, 12],
  });
};
